import { render, staticRenderFns } from "./CustomWebsiteContactCard.vue?vue&type=template&id=59784f00&scoped=true"
import script from "./CustomWebsiteContactCard.vue?vue&type=script&lang=js"
export * from "./CustomWebsiteContactCard.vue?vue&type=script&lang=js"
import style0 from "./CustomWebsiteContactCard.vue?vue&type=style&index=0&id=59784f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59784f00",
  null
  
)

export default component.exports